import React, { Fragment, useCallback, useContext, useMemo, useState } from "react";

import UIPopupContext from "../../popups/UIPopup/UIPopupContext";
import {editPrompt} from "../aiApi";
import UiPopupAIContentEditingModal from "./UiPopupAIContentEditingModal";
import {setUiPopupState} from "../../../actions/actionFunctions";
import {useAppDispatch, useAppSelector} from "../../../storeHooks";

const UiPopupAIContentPrompts = (props) => {

  const {type} = props;

  const dispatch = useAppDispatch();
  const {uiPopupState} = useAppSelector(state => state.messageBoxState);

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);
  const {promptsList} = uiPopupContext;

  const [isEditingPrompt, setIsEditingPrompt] = useState(false);

  const isActiveType = "isActive" + type;

  const activePrompt = useMemo(() => {
    if (!promptsList) return null;
    return promptsList.find((promptObject) => promptObject[isActiveType]);
  }, [promptsList, isActiveType]);

  const openEditor = useCallback(() => {
    if (!activePrompt) return;
    dispatch(setUiPopupState({
      ...uiPopupState,
      style: {maxWidth: "98%", maxHeight: "95%"}
    }));
    setIsEditingPrompt(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePrompt, uiPopupState]);

  const closeEditor = useCallback(
    async (newValue) => {
      setIsEditingPrompt(false);
      if (!activePrompt) return;

      dispatch(setUiPopupState({
        ...uiPopupState,
        style: {maxWidth: "98%", maxHeight: "95%"}
      }));

      // 1) update prompt body in context
      uiPopupDispatch({
        promptsList: promptsList.map((p) => {
          if (p.id === activePrompt.id) {
            return { ...p, promptBody: newValue };
          }
          return p;
        }),
      });

      // 2) persist
      await editPrompt({ ...activePrompt, promptBody: newValue });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activePrompt, promptsList, uiPopupDispatch, uiPopupState]
  );

  if (!promptsList || !activePrompt) return null;

  return (
    <Fragment>
      {/* Preview textarea (small) */}
      <textarea
        className="u-h-full u-w-full ui-input"
        value={activePrompt.promptBody || ""}
        readOnly
        onFocus={openEditor}
        onClick={openEditor}
      />
      <UiPopupAIContentEditingModal
        propsOpened={isEditingPrompt}
        propsTitle={type + " Prompt"}
        propsValue={activePrompt?.promptBody || ""}
        propsClose={closeEditor}
      />
    </Fragment>
  );
};

export default UiPopupAIContentPrompts;
